import compose from 'ramda/src/compose.js'
import isNil from 'ramda/src/isNil.js'
import isEmpty from 'ramda/src/isEmpty.js'
import either from 'ramda/src/either.js'
import not from 'ramda/src/not.js'
import any from 'ramda/src/any.js'
import all from 'ramda/src/all.js'

export const isEmptyOrNil = either( isNil, isEmpty );
export const notEmptyOrNil = compose( not, isEmptyOrNil );
export const anyNotEmptyOrNil = any( notEmptyOrNil );
export const anyEmptyOrNil = any( isEmptyOrNil );
export const allEmptyOrNil = all( isEmptyOrNil );
